import application from 'application/application';

application.directive('ngGroupPermission', [
	'$http',
	'helper',
	'API',
	'authentication',
	($http, helper, API, authentication) => ({
		restrict: 'A',
		scope: {
			click: '&'
		},
		link($scope, element, attrs) {
			element.on('click', event => {
				event.preventDefault();
				const selectedGroup =
					localStorage.getItem('__groupSelected__') || false;

				if (selectedGroup === 'true') {
					const groupData = JSON.parse(
						localStorage.getItem('__groupUserData__')
					);

					$http({
						...helper.http(API.groupUsers, 'GET'),
						params: {
							...helper.httpFields(['*']),
							idsGrupoUsuarios: [groupData.idGrupo],
							idsSituacaoGrupoUsuario: [-1],
							paginaAtual: 1,
							registrosPorPagina: 10
						}
					})
						.then(response => {
							let groupUser = response.data.itens[0].listaUsuariosGrupo.filter(
								user =>
									user.idUsuarioCliente ==
									authentication.getUserData('idUsuarioCliente')
							);

							$scope.hasGroupPermission = groupUser[0]
								? groupUser[0].administrador
								: false;
						})
						.finally(() => {
							if ($scope.hasGroupPermission) {
								if (attrs.target) {
									$(attrs.target).modal();
								}

								if ($scope.click) {
									$scope.click();
								}
							} else {
								event.preventDefault();

								$('#modalNotPermitted').modal('show');

								return false;
							}
						});
				} else {
					if (attrs.target) {
						$(attrs.target).modal();
					}

					if ($scope.click) {
						$scope.click();
					}
				}
			});
		}
	})
]);
